/* ============================================================
   The Cambie — launch landing page
   Ported from reference/Cambie Launch LP/app.js.

   Kept: colourway picker (image + accent + name + CTA link/label),
   scroll reveal.

   Dropped on purpose:
   - Mode (presale/in-stock) copy-swap — mode is a real section
     setting now, resolved server-side in cambie-launch.liquid.
   - Currency/store detection — price comes from the real product's
     `| money` output server-side, already correct for the buyer's
     market via Shopify's own localization. No hardcoded price table.
   - The .pmode preview switcher and its listeners — the reference
     file's own comment says to delete this before publishing.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('.cambie-lp');
  if (!root) return;

  var colour = 'purple';

  function applyColour() {
    var pick = root.querySelector('.pick');
    if (pick) pick.setAttribute('data-cw', colour);
    root.setAttribute('data-cw', colour);

    root.querySelectorAll('[data-cw-img]').forEach(function (img) {
      img.classList.toggle('is-on', img.getAttribute('data-cw-img') === colour);
    });

    var selectedLabel = '';
    root.querySelectorAll('[data-cw-btn]').forEach(function (btn) {
      var on = btn.getAttribute('data-cw-btn') === colour;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) {
        var lbl = btn.querySelector('.sw__lbl');
        selectedLabel = lbl ? lbl.textContent : '';
      }
    });

    var name = root.querySelector('[data-cw-name]');
    if (name) name.textContent = selectedLabel;

    var link = root.querySelector('[data-cw-link]');
    if (link) {
      var template = link.getAttribute('data-pickcta-template') || '';
      var span = link.querySelector('span');
      if (span) span.textContent = template.replace('[colour]', selectedLabel);

      var buyUrl = link.getAttribute('data-buy-url');
      if (buyUrl) {
        link.href = buyUrl + (buyUrl.indexOf('?') > -1 ? '&' : '?') + 'Color=' + encodeURIComponent(selectedLabel);
      }
    }
  }

  root.querySelectorAll('[data-cw-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      colour = btn.getAttribute('data-cw-btn');
      applyColour();
    });
  });

  applyColour();

  /* ---------------- reveal ---------------- */

  function reveal() {
    var targets = root.querySelectorAll(
      '.proof, .pick__grid, .lineup, .why__head, .card, .fit__media, .fit__body, ' +
        '.says__head, .say, .spec__head, .spec__table, .gal__head, .gal__grid, ' +
        '.founder__media, .founder__q, .closer'
    );
    targets.forEach(function (t) { t.setAttribute('data-reveal', ''); });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    targets.forEach(function (t) { io.observe(t); });
  }

  reveal();
})();
